import { ActionsObservable, StateObservable } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { actionCreators, GET_CLIENT_CONFIG, GET_NATGEO_FOOTER_LINKS } from '@src/app/main/actions';
import { mergeMap, map, flatMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ajax } from 'rxjs/observable/dom/ajax';
import { concat } from 'rxjs/observable/concat';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';

export function configEpic(action$: ActionsObservable<RootAction>) {
  var adminUrl = `${process.env.SERVICE_DISCOVERY_URL}/serviceDiscovery`;

  return action$.ofType(GET_CLIENT_CONFIG).pipe(
    mergeMap(() => {
      const loading = of(actionCreators.clientConfigLoading(true));
      const request = ajax.getJSON(adminUrl).pipe(
        flatMap((response: any) => {
          return ajax
            .getJSON(
              response.url + '/AdminConfig?globalCode=' + encodeURIComponent(response.globalCode),
            )
            .pipe(
              map((res: any) =>
                actionCreators.clientConfigSuccess({
                  clientConfig: response,
                  adminConfig: res,
                }),
              ),
            );
        }),
        catchError((err: any) => {
          return of(actionCreators.clientConfigFailure(err));
        }),
      );

      return concat(loading, request);
    }),
  );
}

export function natGeoFooterLinksEpic(action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) {
  return action$.ofType(GET_NATGEO_FOOTER_LINKS).pipe(
    mergeMap(() => {
      let footerData = getAdminConfigTableItem(
        state$.value.adminConfig,
        state$.value.clientConfig,
        'PageFooter',
      );
      var footerUrl = footerData.NatGeoCustomFooter && footerData.NatGeoCustomFooter.NatGeoFooterUrl || '';

      const request = ajax.getJSON(footerUrl).pipe(
        flatMap((response: any) => {
          document.cookie = 'country=' + response.country + '; path=/;';
          return ajax
            .getJSON(
              `${footerData.NatGeoCustomFooter.NatGeoCountryBaseUrl}${response.country}.json`
            )
            .pipe(
              map((res: any) =>
                actionCreators.natGeoFooterLinksSuccess(res),
              ),
            );
        }),
        catchError((err: any) => {
          return of(actionCreators.natGeoFooterLinksFailure(err));
        }),
      );

      return concat(request);
    }),
  );
}
